import { ActivityIndicator, Image, View } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";

const USE_GIF = true;

export function CustomActivityIndicator(props) {
  if (props.hide) {
    return null;
  } else {
    let style = {};

    if (props.absoluteBottom) {
      style = {
        position: "absolute",
        bottom: 0,
        padding: 15,
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
      };
    } else if (props.absoluteCenter) {
      style = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0, 
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
      };
    }

    if (USE_GIF) {
      return (
        <View style={style}>
          <Image source={require("../../assets/loading.gif")} style={{ width: 70, height: 10 }} />
        </View>
      );
    } else {

      // https://reactnative.dev/docs/activityindicator
      // https://github.com/facebook/react-native/blob/master/Libraries/Components/ActivityIndicator/ActivityIndicator.js

      return (
        <View style={style}>
          <View
            style={{
              width: props.small ? 20 : 40,
              height: props.small ? 20 : 40,
              backgroundColor: "transparent",
              //backgroundColor: isAndroid() ? "white" : "transparent",
              borderRadius: props.small ? 10 : 20,
              alignSelf: "center",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: AppUtilities.isAndroid() ? 0 : 3,
              paddingTop: AppUtilities.isAndroid() ? 0 : 3,
              paddingRight: props.paddingRight ? props.paddingRight : 0,
            }}
          >
            <ActivityIndicator
              size={props.small ? "small" : "large"}
              color={props.dark ? "#000000" : "#ffffff"}
            />
          </View>
          {
            props.percent ?
              <View
                style={{
                  backgroundColor: "white",
                  alignSelf: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 5,
                  padding: 5,
                }}
              >
                <Text>{props.percent}%</Text>
              </View>
              : null
          }
        </View>
      );
    }
  }
}
